import React from 'react'
import { MainHeading, PageHeaderIntro, FindAgent, Breadcrumb, FigureCards, Faq, NewsCard } from '../../../../components';
import { images } from "../../../../utils/customFn";
import { Container } from 'react-bootstrap';
import './crime-insurance.scss'

const CrimeInsurance = () => {

    const HeaderData = [
        {
            image: images['two-blue-shields-card.svg'],
            para: 'Although we hope it never happens, anyone can be victim to a crime, and your business can be, too. In some cases, crime-related losses aren’t covered by a standard commercial property insurance policy. That’s where crime insurance comes in. We want to help you be sure your business is protected from crimes like theft, fraud, and forgery.',
        },
    ];
    const breadcrumbs = [
        { label: "Sentry Insurance home", link: "/" },
        { label: "What we offer", link: "/what-we-offer" },
        { label: "Insurance products", link: "/what-we-offer/insurance-products" },
        { label: "Commercial property insurance", link: "/what-we-offer/insurance-products/commercial-property-insurance" },
        { label: "Crime insurance", link: "/what-we-offer/insurance-products/commercial-property-insurance/crime-insurance" },
    ];
    const faqData = [
        {
            id: 1,
            eventKey: 1,
            header: 'Does my business need crime coverage?',
            body: 'We help owners like you determine the right insurance policy that balances the best combination of price and protection for your business—from Call us for more information or find a local insurance agent to get started on your personalized quote.'
        },
        {
            id: 2,
            eventKey: 2,
            header: 'How can I reduce the risk of employee theft?',
            body: 'We help owners like you determine the right insurance policy that balances the best combination of price and protection for your business—from Call us for more information or find a local insurance agent to get started on your personalized quote.'
        },
        {
            id: 3,
            eventKey: 3,
            header: 'At my business, I use a lot of expensive machinery and equipment. It’s only used inside the building, so is it covered by building property insurance?',
            body: 'We help owners like you determine the right insurance policy that balances the best combination of price and protection for your business—from Call us for more information or find a local insurance agent to get started on your personalized quote.'
        }
    ]
    const featuredCard = [
        {
            id: 1,
            value: "5k+",
            unit: "Sentry associates",
            description: "While we’ve been in business a long time, we’ve had just eight leaders during our more than 120-year history.",
        },
        {
            id: 2,
            value: "8",
            unit: "Sentry leaders",
            description: "While we’ve been in business a long time, we’ve had just eight leaders during our more than 120-year history.",
        },
        {
            id: 3,
            value: "1992",
            unit: "First year",
            description: "While we’ve been in business a long time, we’ve had just eight leaders during our more than 120-year history.",
        },
    ];
    const NewsCardData = [
        {
            id: 1,
            title: 'Getting your employees ready to retire',
            description:
                'We have the 401(k) and other retirement plan options and services to help you and your employees plan for retirement.',
            linkUrl: '',
            linkText: 'Read more >',
        },
        {
            id: 2,
            title: 'Secure Act 2.0',
            description: 'Running a business comes with uncertainties. Protect yourself from the unknown with business liability coverage.',
            linkUrl: '/',
            linkText: 'Read more >',
        },
        {
            id: 3,
            title: 'Sentry news',
            description:
                'Protect your profits and property from the unexpected during a construction or renovation project.',
            linkUrl: '/',
            linkText: 'Read more >',
        },

    ];
    return (
        <div className='crime-insurance-main'>
            <Container>
                {/* Breadcrum */}
                <Breadcrumb crumbs={breadcrumbs} />

                {/* heading  */}
                <MainHeading title="Crime insurance" showshare={false} />

                {/* page intro */}
                <PageHeaderIntro Data={HeaderData} />

                <Faq heading="FAQs" FaqData={faqData} />

                <FigureCards data={featuredCard} heading="Significant figures" />

                {/* news card section */}
                <NewsCard Title="More reasons to choose Sentry" CardData={NewsCardData} showNavLink={false} subTitle="GUIDES" />

                <FindAgent />
            </Container>
        </div>
    )
}

export default CrimeInsurance;